/**
 * @fileOverview Menu
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Local:Search
 * @requires Local:Menu
 * @requires Local:MenuBar
 * @requires Local:fixed-header
 */

import Search from './modules/search';
import Menu from './modules/menu';
import MenuBar from './modules/menu-bar';
import initFixedHeader from './fixed-header';

export default () => {
  Search.initialization();
  Menu.initialization();
  MenuBar.initialization();
  initFixedHeader();
}
